<div class="form-header">
  <span *ngIf="edited.id && edited.id > 0">Edit</span>
  <span *ngIf="!edited.id || edited.id === -1">Add</span>
  checklist template
</div>

<form [formGroup]="checklistTemplateForm" (ngSubmit)="onSubmitForm()" >
  
<div class="dialog-container">
 
  <div class="fields">
    <div class="field" required>
      <mat-form-field>
        <mat-label>Checklist template name</mat-label>
        <input matInput formControlName="name" maxlength="50" name="name">
      </mat-form-field>
    </div>
    
    <div class="edit-panel">
      <div class="field" required >
        <mat-form-field appearance="fill">
          <mat-label>Item</mat-label>
          <input matInput formControlName="item" maxlength="50" name="item">
        </mat-form-field>
      </div>
      <div class="quarter-field" required >
        <mat-form-field  >
          <mat-label>Service</mat-label>
          <mat-select  name="service" formControlName="service" >
            <mat-option *ngFor="let r of services" [value]="r">{{r.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="quarter-field" required >
          <mat-slide-toggle formControlName="required">Required?</mat-slide-toggle>
      </div>
      <div class="quarter-field" required >
        <mat-form-field appearance="fill">
          <mat-label>Required By Appt. #</mat-label>
          <input matInput formControlName="requiredByAppNum" maxlength="2" type="number" name="requiredByAppNum">
        </mat-form-field>
    </div>
      <div class="edit-panel-buttons">
      <button class="edit-panel-button" mat-raised-button color="secondary" type="button"  (click)="createNewItem()">New</button>
      <button class="edit-panel-button" mat-raised-button color="secondary" type="button" [disabled]="!hasCompleteItem()" (click)="saveItem()">Save</button>
      <button class="edit-panel-button" mat-raised-button color="secondary" type="button" [disabled]="!hasCompleteItem()" (click)="deleteItem()">Delete</button>
      </div>

    </div>
    <div class="services-list">
      <table mat-table [dataSource]="items" class="">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>Select One</th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="onItemSelected($event, row)"
                          [checked]="selection.isSelected(row)"
                          >
            </mat-checkbox>
          </td>
        </ng-container>
      
        <!-- item Column -->
        <ng-container matColumnDef="item">
          <th mat-header-cell *matHeaderCellDef> Item </th>
          <td mat-cell *matCellDef="let element"> {{element.item}} </td>
        </ng-container>
      
        <!-- service Column -->
        <ng-container matColumnDef="service">
          <th mat-header-cell *matHeaderCellDef> Service </th>
          <td mat-cell *matCellDef="let element">{{getServiceName(element.serviceId)}} </td>
        </ng-container>

        <ng-container matColumnDef="required">
          <th mat-header-cell *matHeaderCellDef> Required? </th>
          <td mat-cell *matCellDef="let element"> <span *ngIf="element.required">Yes</span><span *ngIf="!element.required">No</span></td>
        </ng-container>
        <ng-container matColumnDef="requiredByAppNum">
          <th mat-header-cell *matHeaderCellDef> Required By Appt. # </th>
          <td mat-cell *matCellDef="let element">{{element.requiredByAppNum}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            (click)="selection.toggle(row)">
        </tr>
      </table>
    </div>
  </div>    
</div>  
 
  <div class="button-container">
    <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button color="primary" >Save</button>

    <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
  </div>


</form>
